import React from "react";
import env from "env";
import { Redirect, Link } from "react-router-dom";
import { usePost } from "components";
import { useForm } from "form";
import { Button, ErrorMessage } from "components";
import { ImageSelector } from "./imageSelector";
import { MediaSelector } from "./mediaSelector";
import { MetaImageSelector } from "./metaImageSelector";
import { StoreSelector } from "./storeSelector";
import utils from "utils";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaGripLines, FaRegEyeSlash, FaRegEye, FaTrash } from "react-icons/fa";
import { createGroup } from "./productEditFormModel";

export function ProductEditForm({ model, data, productCode }) {
  const form = useForm(model, {});
  const post = usePost();
  const [currentTab, setCurrentTab] = React.useState("details");

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue(), orgProductCode: productCode };
      value.relatedProducts = value.relatedProducts
        ? value.relatedProducts.split("\n")
        : [];
      post.send(env.apiBase + "/api/productAdmin/saveProduct", value);
    });
  }

  // function remove(e) {
  //   if (!window.confirm("Delete this??")) return;
  //   post.send(env.apiBase + "/api/productAdmin/removeProduct", { productCode: productCode });
  // }

  function suggestUrl() {
    const value = form.getValue();
    const productUrl = form.findControl("productUrl");
    productUrl.value = "/products/" + utils.url.getSlug(value.productName);
    form.reset();
  }
  // if (post.hasErrors()) {
  //   return <ErrorPopup title="Sending Error" errors={post.errors} />
  // }
  if (post.status === "done") {
    return <Redirect to='/admin/products' />;
  }

  const tabs = [
    //{ id: 'howto', title: 'Style Tips', tabView: HowtoTab },
    { id: "details", title: "Details", tabView: DetailsTab },
    { id: "wheretobuy", title: "Where to buy", tabView: WhereToBuyTab },
    { id: "specifications", title: "Specifications", tabView: SpecTab },
    { id: "seemore", title: "Recipes", tabView: SeeMoreTab },
    { id: "discover", title: "Discover More", tabView: DiscoverMoreTab },
    { id: "faq", title: "FAQs", tabView: FaqTab },
    { id: "related", title: "Related", tabView: RelatedTab },
    { id: "photos", title: "Photos", tabView: PhotoTab },
    { id: "google", title: "Google MF", tabView: GoogleMF },
    // { id: 'youtube', title: 'Youtube', tabView: Youtube }
  ];

  function showTab(tab) {
    setCurrentTab(tab);
  }

  //const baseUrl = data.menOrWomen === 'M' ? env.baseUrlMen : env.baseUrlWomen;
  const baseUrlAU = env.baseUrlAU;
  const productUrlAU = data.productUrl
    ? baseUrlAU + data.productUrl
    : `${baseUrlAU}/product/${data.productCode}`;
  const baseUrlNZ = env.baseUrlNZ;
  const productUrlNZ = data.productUrl
    ? baseUrlNZ + data.productUrl
    : `${baseUrlNZ}/product/${data.productCode}`;

  const formVal = form.getValue();
  return (
    <div className='editor productEditor'>
      <div className='productEditor__links'>
        {/* {data.productUrl && <a href={`${baseUrl}${data.productUrl}`} rel="noopener noreferrer" target="_blank">Product page</a>} */}
        {formVal.productStatusAU !== 99 && (
          <a href={productUrlAU} rel='noopener noreferrer' target='_blank'>
            Product (AU)
          </a>
        )}
        {formVal.productStatusNZ !== 99 && (
          <a href={productUrlNZ} rel='noopener noreferrer' target='_blank'>
            Product (NZ)
          </a>
        )}
        {/* {data.migProductUrl && (
          <a href={`${data.migProductUrl}`} rel="noopener noreferrer" target="_blank">
            Old page
          </a>
        )} */}
      </div>
      <h1>Product Edit</h1>

      <section>
        <div className='row'>
          <div className='col-md-3'>{render("productCode")}</div>
          <div className='col-md-3'></div>
          <div className='col-md-3'>{render("category")}</div>
          <div className='col-md-3'>{render("category2")}</div>
        </div>
        <div className='row'>
          <div className='col-md-6'>{render("productName")}</div>
          <div className='col-md-6'>
            {render("productUrl")}
            <div style={{ textAlign: "right" }}>
              <button
                type='button'
                className='btn btn-outline-info btn-sm'
                onClick={suggestUrl}
              >
                Suggest URL from product name
              </button>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='col-md-6'>{render("productStatusAU")}</div>
              <div className='col-md-6'>{render("productStatusNZ")}</div>
            </div>

            <div className='row'>
              <div className='col-md-6'>{render("priceAU")}</div>
              <div className='col-md-6'>{render("priceNZ")}</div>
            </div>

            <div className='row'>
              <div className='col-md-6'>{render("warranty")}</div>
              <div className='col-md-6'>
                <label className='label'>Spare Part Instruction</label>
                {render("useSparePartInstruction")}
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>{render("barcode")}</div>
              <div className='col-md-6'>{render("barcodeUPC")}</div>
            </div>
            <div className='row'>
              <div className='col-12'>
                {render("bookletLink")}
                <MediaSelector
                  form={form}
                  data={data}
                  fieldName='bookletLink'
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                {render("recipeBookletLink")}
                <MediaSelector
                  form={form}
                  data={data}
                  fieldName='recipeBookletLink'
                />
              </div>
            </div>
            <div
              className='row'
              style={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              <div className='col-12'>
                <label className='label'>Meta Images</label>
                <MetaImageSelector
                  form={form}
                  data={data}
                  fieldName='metaImage'
                />
              </div>
            </div>
          </div>

          <div className='col-md-6'>
            <div className='row'>
              <div className='col-12'>{render("sortingOrder")}</div>
            </div>
            {/* {data.menOrWomen === 'W' && render('styles')} */}
            <label className='label'>Trending Now</label>
            {render("trendingNow")}
            {render("filters")}
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>
            {render("intro")}
            <WordCounter form={form} field='intro' forMeta={false} />
          </div>
          <div className='col-md-6'>
            {render("metaDesc")}
            <WordCounter form={form} field='metaDesc' forMeta={true} />
          </div>
        </div>
        <div className='row' style={{ marginTop: "3rem" }}>
          <div className='col-12'>
            <div className='productEditor__tabs'>
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`tab ${
                    (currentTab === tab.id && "selected") || ""
                  }`}
                  onClick={(e) => showTab(tab.id)}
                >
                  {tab.title}
                </div>
              ))}
            </div>

            <div className='productEditor__tabContents'>
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  className={`tabContent ${
                    (currentTab === tab.id && "selected") || ""
                  }`}
                >
                  <tab.tabView form={form} data={data} />
                </div>
              ))}
            </div>
          </div>

          {/* <div className="col-md-6">
            <div className="row">
              <div className="col-12">{render('details')}</div>
            </div>
            
           
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-12">{render('styleTips')}</div>
            </div>
            <div className="row">
              <div className="col-12">{render('specifications')}</div>
            </div>
            <div className="row">
              <div className="col-12">{render('seeMore')}</div>
            </div>
          </div> */}
        </div>

        <div className='row'>
          <div className='col-12 actions'>
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>
              Save
            </Button>
            {/* {productCode && (
              <Button onClick={remove} status={form.status} btnStyle="outline-primary">
                Delete
              </Button>
            )} */}
            <Link className='btn btn-outline-dark' to='/admin/products'>
              Cancel
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function WordCounter({ form, field, forMeta }) {
  const val = form.getValue()[field];
  const length = (val || "").length;
  const style = {
    color: forMeta
      ? length < 50 || length > 160
        ? "red"
        : "limegreen"
      : "#666",
    fontSize: "0.8rem",
  };
  return (
    <div style={style}>
      {length} {length === 1 ? "character" : "characters"}
      {forMeta && (
        <span style={{ color: "#666", marginLeft: "1rem" }}>
          (50-160 characters recommended)
        </span>
      )}
    </div>
  );
}

// function HowtoTab({ form }) {
//   const section = form.findControl('howToSection');
//   const addOptions = [
//     { name: 'Html', itemTypeCode: 'html' },
//     { name: 'Video', itemTypeCode: 'video' }
//   ]
//   return <EditorPanel form={form} section={section} addOptions={addOptions} />;
// }

function DiscoverMoreTab({ form }) {
  const section = form.findControl("discoverMoreSection");
  const addOptions = [{ name: "Web Link", itemTypeCode: "weblink" }];
  return <EditorPanel form={form} section={section} addOptions={addOptions} />;
}

function FaqTab({ form }) {
  const section = form.findControl("faqSection");
  const addOptions = [{ name: "Q&A", itemTypeCode: "qa" }];
  return <EditorPanel form={form} section={section} addOptions={addOptions} />;
}

function DetailsTab({ form }) {
  const section = form.findControl("detailSection");
  const addOptions = [
    { name: "Html", itemTypeCode: "html" },
    { name: "Video", itemTypeCode: "video" },
  ];
  return <EditorPanel form={form} section={section} addOptions={addOptions} />;
}

function SpecTab({ form }) {
  const section = form.findControl("specSection");
  const addOptions = [
    { name: "Html", itemTypeCode: "html" },
    { name: "Spec", itemTypeCode: "spec" },
  ];
  return <EditorPanel form={form} section={section} addOptions={addOptions} />;
}

function SeeMoreTab({ form }) {
  const section = form.findControl("seeMoreSection");
  const addOptions = [
    { name: "Html", itemTypeCode: "html" },
    { name: "Link", itemTypeCode: "link" },
  ];
  return <EditorPanel form={form} section={section} addOptions={addOptions} />;
}

function RelatedTab({ form, data }) {
  const render = (name) => form.renderControl(name);
  return (
    <div className='row'>
      <div className='col-md-6'>{render("relatedProducts")}</div>
      <div className='col-md-6'>
        <div className='form-group'>
          <label className='label'>
            Reference - Related Products from the current site
          </label>
          <pre>{data.migRelatedProducts.join("\n")}</pre>
        </div>
      </div>
    </div>
  );
}

function EditorPanel({ form, section, addOptions }) {
  //const section = form.findControl('detailSection');
  //console.log(section)
  //return null;
  // section.controls.map((item, index) => {
  //   console.log(item.controls[0].value)
  // });

  function onDragEnd(result) {
    //console.log(result)

    // dropped outside the list
    if (!result.destination) {
      return;
    }

    //console.log(JSON.stringify(section))
    section.controls = utils.array.moveItem(
      Array.from(section.controls || []),
      result.source.index,
      result.destination.index
    );
    // console.log(JSON.stringify(section))
    // console.log(JSON.stringify(form.model))
    form.reset();
  }

  function removed(id) {
    console.log(id);
    section.controls = section.controls.filter((x) => x.id !== id);
    form.reset();
  }

  // function deleteAll() {
  //   if (!window.confirm("Delete all?")) return;
  //   section.controls = [];
  //   form.reset();
  // }

  function activateAll() {
    section.controls.forEach((item) => {
      item.find("itemStatus").value = 0;
    });
    form.reset();
  }

  function deactivateAll() {
    section.controls.forEach((item) => {
      item.find("itemStatus").value = 99;
    });
    form.reset();
  }

  function addItem(e) {
    console.log(e.target.value);
    const itemTypeCode = e.target.value;
    let itemValue = "";
    if (itemTypeCode === "video") {
      itemValue = JSON.stringify({
        videoUrl: "",
        title: "",
        desc: "",
        posterImage: "",
      });
    } else if (itemTypeCode === "qa") {
      itemValue = JSON.stringify({ question: "", answer: "" });
    } else if (itemTypeCode === "spec") {
      itemValue = JSON.stringify({ category: "L", label: "", text: "" });
    } else if (itemTypeCode === "link") {
      itemValue = JSON.stringify({ linkType: "auto", title: "", url: "" });
    } else if (itemTypeCode === "weblink") {
      itemValue = JSON.stringify({ linkType: "auto", title: "", url: "" });
    }

    const group = createGroup({
      itemTypeCode: itemTypeCode,
      itemValue: itemValue,
      itemStatus: 0,
    });
    console.log(group);
    section.controls.push(group);
    form.reset();
    console.log(form);
  }

  return (
    <div className='editSection'>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='droppable'>
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`editSection__list ${
                snapshot.isDraggingOver ? "editSection__list--dragging" : ""
              }`}
              // style={getListStyle(snapshot.isDraggingOver)}
            >
              {section.controls.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={provided.draggableProps.style}
                      className={`editSection__item ${
                        snapshot.isDragging ? "editSection__item--dragging" : ""
                      }`}
                    >
                      <ItemEditor
                        form={form}
                        item={item}
                        provided={provided}
                        removed={removed}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <div className='editSection__actions'>
        <span>For all items in this section,</span>
        <button className='btn btn-warning' onClick={activateAll}>
          Activate all{" "}
        </button>
        <button className='btn btn-warning' onClick={deactivateAll}>
          Deactivate all{" "}
        </button>
        {/* <button className="btn btn-warning" onClick={deleteAll}>
          Delete all{" "}
        </button> */}
        {addOptions && (
          <span>
            <select className='form-control' onChange={addItem} value={""}>
              <option value=''>Add Item</option>
              {addOptions.map((x, index) => (
                <option value={x.itemTypeCode} key={index}>
                  {x.name}
                </option>
              ))}
            </select>
          </span>
        )}
      </div>
      {/* {section.controls.map(item => <ItemEditor key={item.id} form={form} parent={section} item={item} />)} */}
    </div>
  );
}

function ItemEditor({ form, item, provided, removed }) {
  const itemStatus = item.find("itemStatus").value; // form.findControl('itemTypeCode', item);
  //console.log(itemStatus, typeof itemStatus)
  function toggleItem() {
    const itemStatus = item.find("itemStatus").value;
    item.find("itemStatus").value = itemStatus === 99 ? 0 : 99;
    form.reset();
  }

  function removeItem() {
    removed(item.id);
  }
  return (
    <div className={`editItem editItem--status-${itemStatus}`}>
      <div className='editItem__controls'>
        <div className='handle' {...provided.dragHandleProps}>
          <FaGripLines title='Change order' />
        </div>
        <div className='visibility'>
          {itemStatus === 99 ? (
            <FaRegEyeSlash title='Disabled' onClick={() => toggleItem()} />
          ) : (
            <FaRegEye title='Visible' onClick={() => toggleItem()} />
          )}
        </div>
        <div className='delete'>
          <FaTrash title='Remove' onClick={() => removeItem()} />
        </div>
      </div>
      <div className='editItem__item'>
        {/* {item.id} */}
        <Item form={form} item={item} />
      </div>
    </div>
  );
}

function Item({ form, item }) {
  const render = (name) => form.renderControl(name, item);
  const itemTypeCode = item.find("itemTypeCode").value; // form.findControl('itemTypeCode', item);
  //console.log(item, itemTypeCode)
  if (itemTypeCode === "video") {
    return (
      <div className='sectionItem row'>
        <div className='col-md-5'>
          <div>{render("videoUrl")}</div>
          <div>{render("title")}</div>
        </div>
        <div className='col-md-7'>{render("desc")}</div>
      </div>
    );
  }
  if (itemTypeCode === "qa") {
    return (
      <div className='sectionItem row'>
        <div className='col-12 col-md-4'>{render("question")}</div>
        <div className='col-12 col-md-8'>{render("answer")}</div>
      </div>
    );
  }
  if (itemTypeCode === "spec") {
    // "{"category": "L","label":"Barrel / Plate size:","text":"19mm Barrel"}"
    return (
      <div className='sectionItem row'>
        <div className='col-2'>{render("category")}</div>
        <div className='col-10 col-md-5'>{render("label")}</div>
        <div className='col-12 col-md-5'>{render("text")}</div>
      </div>
    );
  }
  if (itemTypeCode === "link") {
    return (
      <div className='sectionItem row'>
        <div className='col-2'>{render("linkType")}</div>
        <div className='col-10'>{render("title")}</div>
        <div className='col-12'>{render("url")}</div>
      </div>
    );
  }
  if (itemTypeCode === "weblink") {
    return (
      <div className='sectionItem row'>
        <div className='col-10'>{render("title")}</div>
        <div className='col-12'>{render("url")}</div>
      </div>
    );
  }
  return <>{render("html")}</>;
}

function PhotoTab({ form, data }) {
  return (
    <>
      <ImageSelector form={form} data={data} fieldName='productImages' />
    </>
  );
}

function WhereToBuyTab({ form, data }) {
  return (
    <>
      <StoreSelector form={form} data={data} fieldName='productStores' />
    </>
  );
}

function GoogleMF({ form, data }) {
  const render = (name) => form.renderControl(name);
  return (
    <div className='row'>
      <div className='col-md-6'>
        {render("mpn")}
        {render("mfTitle")}
        {render("mfDesc")}
      </div>
      <div className='col-md-6'>
        {render("mfProductType1")}
        {render("mfProductType2")}
        {render("mfProductType3")}
        {render("mfProductType4")}
        {render("mfProductType5")}
        <div className='ff__help'>
          <a
            href='https://support.google.com/manufacturers/answer/7422668?hl=en&ref_topic=7420644'
            target='_blank'
            rel='noopener noreferrer'
          >
            More info(Google)
          </a>
        </div>
      </div>
      {/* <div className="col-md-6">
      <div className="form-group"><label className="label">Reference - Related Products from the current site</label>
        <pre>{data.migRelatedProducts.join('\n')}</pre>
      </div>
    </div> */}
    </div>
  );
}

// function Youtube({ form }) {
//   const section = form.findControl('youtubeSection');
//   const addOptions = [
//     { name: 'Video', itemTypeCode: 'video' }
//   ]
//   return <EditorPanel form={form} section={section} addOptions={addOptions} />;
// }
